// extracted by mini-css-extract-plugin
export var brand = "_2x-9";
export var button = "_2x-0";
export var chevron = "_2x-v";
export var chevronButton = "_2x-w";
export var content = "_2x-n";
export var danger = "_2x-g";
export var dangerOutlined = "_2x-h";
export var dark = "_2x-l";
export var darkTheme = "_2x-c";
export var extraSmall = "_2x-4";
export var fullWidth = "_2x-8";
export var ghost = "_2x-d";
export var gray = "_2x-t";
export var icon = "_2x-p";
export var iconButton = "_2x-s";
export var iconButtonBorder = "_2x-x";
export var iconButtonBorderDark = "_2x-y";
export var iconButtonBorderLight = "_2x-z";
export var iconLeft = "_2x-q";
export var iconRight = "_2x-r";
export var large = "_2x-1";
export var light = "_2x-m";
export var medium = "_2x-2";
export var micro = "_2x-5";
export var nano = "_2x-7";
export var outlined = "_2x-k";
export var pending = "_2x-a";
export var primary = "_2x-i";
export var shadow = "_2x-o";
export var small = "_2x-3";
export var solidLight = "_2x-e";
export var solidLightBrand = "_2x-f";
export var spinner = "_2x-u";
export var transparent = "_2x-j";
export var warning = "_2x-b";
export var wideNano = "_2x-6";